import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BUILD_DATE } from 'src/app/build-info';

@Component({
  selector: 'prgov-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  buildVersion = BUILD_DATE;
  constructor(
    private router: Router
  ) {}

  ngOnInit() {
  }

  goToFacebook() {
    window.open('https://www.facebook.com/desaludpr', '_blank');
  }
  goToInstagram() {
    window.open('https://www.instagram.com/desaludpr/#', '_blank');
  }

  goToX() {
    window.open('https://x.com/desaludpr', '_blank');
  }

  hasRoute(route: string) {
    return this.router.url.includes(route);
  }

}
